import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { fetchCurrentAgent } from "../../lib/agentAuth";
import { getAgencyRole } from "../../lib/agencyAccess";

export default function AgentLayout({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [agencyRole, setAgencyRole] = useState("");
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    let alive = true;
    fetchCurrentAgent()
      .then((profile) => {
        if (alive) setAgencyRole(getAgencyRole(profile));
      })
      .catch(() => {
        if (alive) setAgencyRole("");
      });
    return () => {
      alive = false;
    };
  }, []);

  useEffect(() => {
    document.body.classList.toggle("overlay-active", mobileOpen);
    return () => document.body.classList.remove("overlay-active");
  }, [mobileOpen]);

  return (
    <div className={`app-shell ${collapsed ? "sidebar-collapsed" : ""}`}>
      <Sidebar
        collapsed={collapsed}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
        agencyRole={agencyRole}
      />
      <main className={`dashboard-main ${collapsed ? "active" : ""}`}>
        <Header
          collapsed={collapsed}
          onToggleSidebar={() => setCollapsed((value) => !value)}
          onToggleMobile={() => setMobileOpen(true)}
          agencyRole={agencyRole}
        />
        <div className="dashboard-main-body">
          {children}
        </div>
        <Footer />
      </main>
    </div>
  );
}
